import { FaHandsClapping } from "react-icons/fa6";
import { FcLike } from "react-icons/fc";
import { FcLikePlaceholder } from "react-icons/fc";
import { PiHandsClapping } from "react-icons/pi";
import { FaRegThumbsUp } from "react-icons/fa";
import { FaThumbsUp } from "react-icons/fa";
import { FaRegSadCry } from "react-icons/fa";
import { FaSadCry } from "react-icons/fa";
import { FaRegAngry } from "react-icons/fa";
import { FaFaceAngry } from "react-icons/fa6";

export const gender = [
  {
    name: "Male",
    value: "MALE",
  },
  {
    name: "Female",
    value: "FEMALE",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

// Twelve years before
export const twelveYearsAgo = new Date();
twelveYearsAgo.setFullYear(twelveYearsAgo.getFullYear() - 18);

// Static Navbar Links
export const navData = [
  // {
  //   name: "About us",
  //   path: "#",
  //   id: "#about",
  // },
  // {
  //   name: "Services",
  //   path: "#",
  //   id: "#services",
  // },
  // {
  //   name: "Testimonials",
  //   path: "#",
  //   id: "#testimonials",
  // },
  {
    name: "FAQs",
    // path: "/dashboard/profile?tab=faq",
    path: '#',
    id: "#faq",
  },
  // {
  //   name: "Contact Us",
  //   path: '#',
  //   id: "#contact",
  // },
];

// Static Footer Links
export const footerData = [
  {
    name: "Home",
    path: "#",
    id: "#home",
  },
  {
    name: "FAQs",
    path: '#',
    id: "#faq",
  },
  // {
  //   name: "About us",
  //   path: "#",
  //   id: "#about",
  // },
  // {
  //   name: "Features",
  //   path: "#",
  //   id: "#services",
  // },
  // {
  //   name: "Testimonials",
  //   path: "#",
  //   id: "#testimonials",
  // },
  // {
  //   name: "Contact us",
  //   path: "#",
  //   id: "#contact",
  // },
];

// Groups Listing
export const groupType = [
  {
    name: "My Group",
    value: "",
  },
  {
    name: "Favourite Group",
    value: "favourite",
  },
  {
    name: "Joined Group",
    value: "joined",
  },
  {
    name: "Explore Group",
    value: "explore",
  },
];

// Group Feeds || Connected Groups
export const groupKey = [
  {
    name: "Feeds",
    value: "feed",
  },
  {
    name: "Connected Groups",
    value: "connected",
  },
];

// Reaction Data
export const reactions = [
  {
    id: "1",
    emoji: <FaRegThumbsUp />,
    fillEmoji: <FaThumbsUp />,
    name: "THUMBS-UP",
  },
  {
    id: "2",
    emoji: <FcLikePlaceholder />,
    fillEmoji: <FcLike />,
    name: "HEART",
  },
  {
    id: "3",
    emoji: <FaRegSadCry />,
    fillEmoji: <FaSadCry />,
    name: "CRY",
  },
  {
    id: "4",
    emoji: <FaRegAngry />,
    fillEmoji: <FaFaceAngry />,
    name: "ANGRY",
  },
  {
    id: "5",
    emoji: <PiHandsClapping />,
    fillEmoji: <FaHandsClapping />,
    name: "CLAP",
  },
];

// Group Feeds || Connected Groups
export const memberGroupType = [
  {
    name: "Created Groups",
    value: "created",
  },
  {
    name: "Joined Groups",
    value: "joined",
  },
];
//---------for-testing----------------
export const nestedArray = [
  [1, 2, 3],
  [4, 5, [6, 7]],
  [8, [9, [10, 11]], 12],
];